module.exports = __webpack_public_path__ + "media/application/images/2018/twitter-blue-a47ad31b85e6b1854e27c9e483bda847.svg";